<template>
	<div class="league">
		<p>
			<i class="el-icon-s-home"></i>
			<span @click="$router.replace('/')">网站首页</span>/ 政策法规/ 联合会会员登记表
		</p>
		<h3 style="text-align:center;margin:20px 0;color:gray">联合会会员登记表</h3>
		<br>
		<a href="http://copyright.gzcc315.com/images/zc.docx">广东省版权保护联合会会员登记表.docx</a>
	</div>
</template>

<script>
	export default {
		data() {
			return {};
		},
		mounted() {},
		methods: {},
	};
</script>
<style scoped>
	.league>p {
		width: 100%;
		border-bottom: 1px solid #ddd;
		padding-bottom: 10px;
		color: gray;
	}

	.league>p i {
		margin-right: 10px;
	}

	.league>p span:hover {
		color: #016fb8;
		cursor: pointer;
	}

	.league a {
		color: #016fb8;
		text-decoration: underline;
	}
</style>
